module.exports = __webpack_public_path__ + "img/hand-holding-droplet.4c8e294b.svg";